import { combineReducers } from 'redux'
import paraphraser from '@chegg-wt/core-wa/state/reducer'
import app from './app/reducer'
import bibliography from './bibliography/reducer'
import citation from './citation/reducer'
import createCitation from './createCitation/reducer'
import currentProject from './currentProject/reducer'
import error from './errors/reducer'
import featureFlags from './featureFlags/reducer'
import folders from './folders/reducer'
import form from './form/reducer'
import modals from './modals/reducer'
import movedCitations from './movedCitations/reducer'
import projects from './projects/reducer'
import styles from './styles/reducer'
import user from './user/reducer'
import instrumentation from './instrumentation/reducer'
import { AppState } from './types'

export default combineReducers<AppState>({
  app,
  bibliography,
  citation,
  createCitation,
  currentProject,
  error,
  featureFlags,
  folders,
  form,
  modals,
  movedCitations,
  projects,
  styles,
  user,
  instrumentation,
  paraphraser,
})
